import { $ } from '@/Engine/state';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader';
import { Group, Mesh, Vector3 } from 'three';
import { textMaterial } from '@/Engine/Ruler/material';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry';
import { IV3D } from '@/Interfaces/v3d';

new FontLoader().load('Montserrat_Bold.json', (font) => {
    $.font = font;
});

declare let v3d: IV3D;
export const simpleTextMaterial = new v3d.MeshBasicMaterial(
    { color: 0x000000 },
);

export class SimpleTextMesh {
    private loader = new FontLoader();
    readonly model: Group=new v3d.Group();
    textMesh: Mesh;
    textGeometry: TextGeometry;

    constructor(text:string) {
        if (!$.font) return;

        // this.textGeometry = this.getTextGeometry(text);
        const geometry = this.getTextGeometry(text,0.04);
        if (!geometry) return;
        this.textMesh = new v3d.Mesh(geometry, simpleTextMaterial);
        this.textMesh.renderOrder = 1;
        // textMesh.rotation.y = Math.PI/2;
        // textMesh.position.z = text.length*0.06;
        this.textMesh.scale.set(1,1,0.002);
        this.model.add(this.textMesh);
    }

    getTextGeometry(text: string,fontSize=0.03) {
        if (!$.font) return;
        return new v3d.TextGeometry(text, {
            font: $.font,
            size:fontSize,
            height: 0.035,
            // bevelEnabled: true,
            // bevelThickness: 8,
            curveSegments: 5,
        });
    }

}